<template>
    <div>
        <div class="xuanfu" id="moveDiv"
             @mousedown="down" @touchstart="down"
             @mousemove="move" @touchmove.prevent="move"
             @mouseup="end" @touchend="end"
             v-if="showSwitch"
        >
            <div class="yuanqiu" @click="openTable(!showTable)">
                {{!showTable?'Chart':'Close'}}
            </div>
        </div>

        <div class="content" :style="contentH" id="content" v-show="showTable">
            <div class="content-div">
                <div class="tab-nav">
                    <div class="tab-item" :class="select_tab==1?'tab-click':''" @click="select_tab=1" >ODD OR EVEN</div>
                    <div class="tab-item" :class="select_tab==2?'tab-click':''" @click="select_tab=2" >BULLS-EYE</div>
                </div>
                <div v-show="select_tab==1">
                    <div class="table" id="table">
                        <div class="table-item">
                            <div class="table-title">Trend of recent 50 periods </div>
                            <div class="table-item-content">
                                <canvas id="game24_chessMode1" class="canvas"></canvas>
                            </div>
                        </div>
                        <div class="table-item">
                            <div class="table-title">Trend of recent 50 periods </div>
                            <div class="table-item-content">
                                <canvas id="game24_chessMode2" class="canvas"></canvas>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-show="select_tab==2">
                    <div class="row" v-for="item in mode3_list">
                        <span>Number-{{item.value}}</span>
                        <span class="Lspan">{{item.last}}times without</span>
                        <span class="Sspan" v-if=" $route.path =='/user/rank'">
                           <div class="btn" @click="goPage">bet</div>
                       </span>
                    </div>
                </div>
            </div>


        </div>
    </div>
</template>
<script>

    export default {
        name: "GameTable",
        props: {
            list:Array,
            showSwitch:{
                type:Boolean,
                default:()=>{
                    return true
                }
            },
            showTable:{
                type:Boolean,
                default:()=>{
                    return false
                }
            },
        },
        components:{

        },
        data: function() {
            return {
                select_tab:1,//选中的tab
                flags: false,
                position: { x: 0, y: 0 },
                nx: '', ny: '', dx: '', dy: '', xPum: '', yPum: '',
                row_H:30,//一格的行高
                row_W:30,//
                line:50,//一共有多少列
                row:10,//一共有多少行
                chess_list:[],//棋子数组 {color,x,y,r}
                mode3_list:[],//图表模式3的数据数组
                contentH:{
                    height:''
                },
                test_mlist:[],
                test_list:[
                    {"time":"04-07 14:38","serial":6200407259,"number":60,"result_value":0,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":60,"result_value":0,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":60,"result_value":0,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":60,"result_value":0,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":60,"result_value":0,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":60,"result_value":0,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":60,"result_value":0,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":60,"result_value":0,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":60,"result_value":0,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":60,"result_value":0,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":60,"result_value":0,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":60,"result_value":0,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":60,"result_value":0,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":59,"result_value":1,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":59,"result_value":1,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":59,"result_value":1,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":59,"result_value":1,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":59,"result_value":1,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":59,"result_value":1,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":59,"result_value":1,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":58,"result_value":0,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":58,"result_value":0,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":58,"result_value":0,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":58,"result_value":0,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":57,"result_value":1,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":57,"result_value":1,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":57,"result_value":1,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":57,"result_value":1,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":57,"result_value":1,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":57,"result_value":1,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":57,"result_value":1,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":57,"result_value":1,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":57,"result_value":1,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":57,"result_value":1,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":57,"result_value":1,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":57,"result_value":1,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":57,"result_value":1,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":57,"result_value":1,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":57,"result_value":1,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":57,"result_value":1,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":56,"result_value":0,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":56,"result_value":0,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":56,"result_value":0,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":56,"result_value":0,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":56,"result_value":0,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":56,"result_value":0,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":56,"result_value":0,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":56,"result_value":0,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":56,"result_value":0,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":56,"result_value":1,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":56,"result_value":1,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":56,"result_value":1,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":56,"result_value":1,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":56,"result_value":1,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":56,"result_value":1,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":56,"result_value":0,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":56,"result_value":0,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":56,"result_value":0,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":56,"result_value":0,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":56,"result_value":0,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":56,"result_value":0,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":56,"result_value":0,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":56,"result_value":0,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":56,"result_value":0,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":56,"result_value":0,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":56,"result_value":0,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":56,"result_value":0,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":56,"result_value":0,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":56,"result_value":0,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":56,"result_value":0,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":56,"result_value":1,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":56,"result_value":1,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":56,"result_value":1,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":56,"result_value":1,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":56,"result_value":1,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":56,"result_value":1,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":56,"result_value":1,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":56,"result_value":1,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":56,"result_value":1,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":56,"result_value":1,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":56,"result_value":1,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":56,"result_value":1,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":56,"result_value":1,"result":"Even&60"},
                    {"time":"04-07 14:38","serial":6200407259,"number":56,"result_value":1,"result":"Even&60"},
                ]

            };
        },
        mounted(){
            //图表初始化在handlechess()结束后执行
            this.handlechess()


        },
        watch: {
            $route(n) {
                if (n.name === "rank") {
                    this.handlechess()
                }
            },
            list(n){

                this.handlechess()
            }
        },
        methods: {
            /**
             * @param canvas Dom元素
             * @param row 生成表格的行数
             * @param line 生成表格的列数
             * 初始化canvas*/
            InitCanvas(canvas,Max_Row=this.row,Max_Line=this.line){
                //绘制表格

                // canvas.width = document.body.clientWidth;
                // canvas.height = document.getElementById('table').offsetHeight;

                canvas.width = this.row_W * Max_Line;
                canvas.height = this.row_H * Max_Row;

                if(canvas.getContext){
                    var ctx = canvas.getContext("2d");

                    ctx.lineWidth = 1
                    ctx.strokeStyle = '#A6A5AA'

                    //绘制横线
                    for(let i = 0;i<Max_Row + 1;i++){
                        let startX = 0
                        let startY = this.row_H * i
                        let stopX = this.row_W * Max_Line
                        let stopY = this.row_H * i

                        ctx.moveTo(startX,startY);
                        ctx.lineTo(stopX,stopY);
                        ctx.stroke();
                    }
                    //绘制竖线
                    for(let i = 0;i<Max_Line + 1;i++){
                        let startX =  this.row_W * i
                        let startY = 0
                        let stopX = this.row_W * i
                        let stopY = this.row_H * Max_Row

                        ctx.moveTo(startX,startY);
                        ctx.lineTo(stopX,stopY);
                        ctx.stroke();
                    }

                    //生成表格上的棋子
                    let chess_array = this.chess_list
                    let game_type = this.$route.query.game_id || 24
                    switch (Number(game_type)) {
                        case 24:
                            //猜奇偶
                            chess_array.forEach(item=>{
                                ctx.beginPath();
                                ctx.arc(item.x * this.row_W + (this.row_W / 2),item.y * this.row_H  + (this.row_H / 2),item.r,0,2*Math.PI);
                                // ctx.stroke();
                                ctx.fillStyle=item.color;
                                ctx.fill();
                                ctx.fillStyle='#fff';
                                ctx.font="20px Arial";
                                ctx.fillText(item.num,item.x * this.row_W + (this.row_W / 4),item.y * this.row_H  + (this.row_H / 1.35));
                            })
                            ;break;
                        case 28:
                            //猜数字
                            chess_array.forEach(item=>{
                                ctx.beginPath();
                                ctx.arc(item.x * this.row_W + (this.row_W / 2),item.y * this.row_H  + (this.row_H / 2),item.r,0,2*Math.PI);
                                // ctx.stroke();
                                ctx.fillStyle=item.color;
                                ctx.fill();
                                ctx.fillStyle='#fff';
                                ctx.font="20px Arial";
                                ctx.fillText(item.num,item.x * this.row_W + (this.row_W / 4),item.y * this.row_H  + (this.row_H / 1.35));
                            })
                            ;break;
                        case 281:
                            //猜数字
                            chess_array.forEach((item,index)=>{
                                ctx.beginPath();
                                ctx.arc(item.x * this.row_W + (this.row_W / 2),item.y * this.row_H  + (this.row_H / 2),item.r,0,2*Math.PI);

                                // ctx.stroke();
                                ctx.fillStyle=item.color;
                                ctx.fill();
                                ctx.fillStyle='#fff';
                                ctx.font="20px Arial";
                                if(item.num<10){
                                    ctx.fillText(item.num,item.x * this.row_W + (this.row_W / 3),item.y * this.row_H  + (this.row_H / 1.4));
                                }else {
                                    ctx.fillText(item.num,item.x * this.row_W +4 ,item.y * this.row_H  + (this.row_H / 1.4));
                                }
                            })
                            ;break;
                    }

                }

            },
            handlechess(){
                let navH = document.getElementById('navTitle').offsetHeight
                let contentH = document.body.offsetHeight

                this.contentH.height=contentH+'px';
                this.chessMode1_V2('game24_chessMode1')

                // this.chessMode1('game24_chessMode1')
                this.chessMode2('game24_chessMode2')
                this.chessMode3()


            },
            chessMode1(cid='chessMode1'){
                //棋盘模式1:
                //如果本期结果和上一期结果相同，那么这个棋子将于上一期棋子同列往下排。
                //也就是说一共50个成员，如果这个数字和上一个数字相同，则X坐标不变，Y坐标+1，反之X坐标+1，Y坐标不变
                let list = this.list
                let last_num = -1
                let line_num = -1 //记录当前排到哪一列了
                let x,y = 0 //设置初始坐标为（0，0）
                let arry = [] //整合的数组
                let game_type = this.$route.query.game_id || 24
                //不同的游戏需要生成不同内容的数组
                switch (Number(game_type)) {
                    case 24:
                        //猜奇偶
                        list.forEach(item=>{
                            if(item.result_value === last_num){x = line_num,y++}
                            else {line_num++,x = line_num,y = 0}
                            arry.push({
                                color:item.result_value==0?'#005BD2':'#BB2922',//0偶数1奇数
                                num:item.result_value==0?'E':'O',
                                x:x,
                                y:y,
                                r:14, //棋子半径
                            })
                            last_num = item.result_value
                        })
                        ;break;
                    case 28:
                        //猜数字
                        list.forEach(item=>{
                            console.log('arry',item.result_value,last_num)
                            let type = item.result_value%2==0?'E':'O'

                            if(type === last_num){

                                x = line_num,y++}
                            else {line_num++,x = line_num,y = 0}
                            arry.push({
                                color:item.result_value%2==0?'#005BD2':'#BB2922',//0偶数1奇数
                                num:item.result_value%2==0?'E':'O',
                                x:x,
                                y:y,
                                r:14, //棋子半径
                            })
                            last_num = type
                        })
                        console.log('arry',arry)
                        ;break;
                }

                this.chess_list = arry
                //数据初始化完毕，开始初始化画布
                let canvas = document.getElementById(cid)
                this.InitCanvas(canvas)
            },
            chessMode1_V2(cid='chessMode1',row=10,line=50){
                //棋盘模式1_升级版V2:现在一列排不开会自动换行
                //如果本期结果和上一期结果相同，那么这个棋子将于上一期棋子同列往下排。
                //也就是说一共50个成员，如果这个数字和上一个数字相同，则X坐标不变，Y坐标+1，反之X坐标+1，Y坐标不变
                let list = this.list
                let last_num = -1
                let line_num = -1 //记录当前排到哪一列了
                let x,y = 0 //设置初始坐标为（0，0）
                let arry = [] //整合的数组
                let game_type = this.$route.query.game_id || 24
                //不同的游戏需要生成不同内容的数组
                switch (Number(game_type)) {
                    case 24:
                        //猜奇偶
                        list.forEach(item=>{
                            if(item.result_value === last_num){
                                if(y<row){
                                    x = line_num,y++
                                }else{
                                    line_num++,x = line_num,y = 0
                                }
                            }
                            else {line_num++,x = line_num,y = 0}
                            arry.push({
                                color:item.result_value==0?'#005BD2':'#BB2922',//0偶数1奇数
                                num:item.result_value==0?'E':'O',
                                x:x,
                                y:y,
                                r:14, //棋子半径
                            })
                            last_num = item.result_value
                        })
                        ;break;
                    case 28:
                        //猜数字
                        list.forEach(item=>{
                            let type = item.result_value%2==0?'E':'O'

                            if(type === last_num){

                                x = line_num,y++
                                console.log('row',y,row)

                                if(y>row-1){
                                    line_num++,x = line_num,y = 0
                                }
                            }
                            else {line_num++,x = line_num,y = 0}
                            arry.push({
                                color:item.result_value%2==0?'#005BD2':'#BB2922',//0偶数1奇数
                                num:item.result_value%2==0?'E':'O',
                                x:x,
                                y:y,
                                r:14, //棋子半径
                            })
                            last_num = type
                        })
                        ;break;
                }

                this.chess_list = arry
                //数据初始化完毕，开始初始化画布
                let canvas = document.getElementById(cid)
                this.InitCanvas(canvas,row,line)
            },
            chessMode2(cid='chessMode2',row=6,line=13){
                //初始化棋盘行数列数
                //棋盘模式2
                //所有的棋子会依次连续从上到下，从左到右排列。每个不同结果到棋子会有不同的颜色区分。
                let list = this.list
                let line_num = 0 //记录当前排到哪一列了
                let row_num = 0 //记录当前排到哪一行了
                let x,y = 0 //设置初始坐标为（0，0）
                let arry = [] //整合的数组
                let game_type = this.$route.query.game_id || 24
                //不同的游戏需要生成不同内容的数组
                switch (Number(game_type)) {
                    case 24:
                        //猜奇偶
                        list.forEach(item=>{
                            if(row_num<row){
                                x=line_num,
                                    y=row_num,
                                    row_num++
                            }else {
                                line_num++,
                                    row_num=0,
                                    x=line_num,
                                    y=row_num
                            }

                            arry.push({
                                color:item.result_value==0?'#005BD2':'#BB2922',//0偶数1奇数
                                num:item.result_value==0?'E':'O',
                                x:x,
                                y:y,
                                r:14, //棋子半径
                            })
                        })
                        ;break;
                    case 28:
                        //猜数字np
                        list.forEach((item,index)=>{
                            if(row_num<row){
                                x=line_num,
                                    y=row_num,
                                    row_num++
                            }else {
                                line_num++,
                                    row_num=0,
                                    x=line_num,
                                    y=row_num
                            }
                            let color = '#3298DB';

                            arry.push({
                                color:item.result_value%2==0?'#005BD2':'#BB2922',//0偶数1奇数
                                num:item.result_value%2==0?'E':'O',
                                x:x,
                                y:y,
                                r:14, //棋子半径
                            })
                        })
                        ;break;
                }

                this.chess_list = arry
                //数据初始化完毕，开始初始化画布
                let canvas = document.getElementById(cid)
                this.InitCanvas(canvas,row,line)
            },

            chessMode3(){
                //棋盘模式3:
                //展示所有的开奖结果在最近的50期内，积累多少期没有开奖过
                let list = this.list

                let arry = [] //整合的数组
                let object,last_times;
                //猜数字
                object = [
                    1, 2, 3, 4, 5, 6, 7, 8, 9,10,
                    11, 12, 13, 14, 15, 16, 17, 18, 19,20,
                    21, 22, 23, 24, 25, 26, 27, 28, 29,30,
                    31, 32, 33, 34, 35, 36, 37, 38, 39,40,
                    41, 42, 43, 44, 45, 46, 47, 48, 49,50,
                    51, 52, 53, 54, 55, 56, 57, 58, 59,60,
                    61, 62, 63, 64, 65, 66, 67, 68, 69,70,
                    71, 72, 73, 74, 75, 76, 77, 78, 79,80,
                ]
                last_times = 0 //多少次没开奖
                object.forEach(val=>{
                    for(let i = 0;i<list.length;i++){
                        let number = list[i].number+''
                        // console.log('number',number)
                        let lastChar = number

                        if(val!==Number(lastChar)){
                            last_times++
                        }else {
                            break;
                        }
                    }
                    arry.push({
                        value:val,
                        last:last_times
                    })
                    last_times = 0
                })


                this.mode3_list = arry
                //数据初始化完毕


            },
            openTable(bool){
                if(bool){
                    this.showTable = true
                    ModalHelper.afterOpen();
                }else {
                    this.showTable = false
                    ModalHelper.beforeClose();
                }

            },
            // 实现移动端拖拽
            down(){
                this.flags = true;
                let touch;
                if(event.touches){
                    touch = event.touches[0];
                }else {
                    touch = event;
                }
                this.position.x = touch.clientX;
                this.position.y = touch.clientY;
                this.dx = moveDiv.offsetLeft;
                this.dy = moveDiv.offsetTop;
            },
            move(){
                if(this.flags){
                    let touch ;
                    if(event.touches){
                        touch = event.touches[0];
                    }else {
                        touch = event;
                    }
                    this.nx = touch.clientX - this.position.x;
                    this.ny = touch.clientY - this.position.y;
                    this.xPum = this.dx+this.nx;
                    this.yPum = this.dy+this.ny;
                    //添加限制:只允许在屏幕内拖动
                    const maxWidth = document.body.clientWidth - 54;//屏幕宽度减去悬浮框宽高
                    const maxHeight = document.body.clientHeight - 54;
                    const minY = document.getElementById("navTitle").offsetHeight

                    if (this.xPum < 0) { //屏幕x限制
                        this.xPum = 0;
                    } else if (this.xPum>maxWidth) {
                        this.xPum = maxWidth;
                    }
                    if (this.yPum < minY) { //屏幕y限制
                        this.yPum = minY;
                    } else if (this.yPum>maxHeight) {
                        this.yPum = maxHeight;
                    }
                    moveDiv.style.left = this.xPum+"px";
                    moveDiv.style.top = this.yPum +"px";
                    //阻止页面的滑动默认事件
                    document.addEventListener("touchmove",this.preventDefault,false);
                }
            },
            //鼠标释放时候的函数
            end(){
                this.flags = false;
                document.removeEventListener('touchmove',this.preventDefault, false);

            },

            preventDefault(e) {
                e.preventDefault();
                // 1.2 如果碰到滑动问题，请注意是否获取到 touchmove
                // event.preventDefault();//jq 阻止冒泡事件
                // event.stopPropagation(); // 如果没有引入jq 就用 stopPropagation()
            },
            goPage(){
                let id = this.$route.query.game_id
                ModalHelper.beforeClose();
                this.$router.push({path:'/hot_new_goods/'+28+'?type=28'})
            }

        },

    };

    //解决遮罩层滚动穿透问题，分别在遮罩层弹出后和关闭前调用
    const ModalHelper = ( (bodyCls) =>{
        let scrollTop;
        return {
            afterOpen: function () {
                scrollTop = document.scrollingElement.scrollTop;
                document.body.classList.add(bodyCls);
                document.body.style.top = -scrollTop + 'px';
            },
            beforeClose: function () {
                document.body.classList.remove(bodyCls);
                // scrollTop lost after set position:fixed, restore it back.
                document.scrollingElement.scrollTop = scrollTop;
            }
        };
    })('dialog-open');

</script>
<style scoped>
    .content{
        width:7.5rem;
        right: 0;
        margin: 0 auto;
        height: 100%;
        background: #fff;
        position: fixed;
        z-index: 5000;
        top: 0rem;
        left: 0px;
        padding-top: 1rem;
    }
    .content-div{
        position: relative;width: 100%;height: 100%;
        padding-top: 1rem;
        overflow-y: auto;
    }
    .xuanfu {
        height: 1.2rem;
        line-height: 1.2rem;
        text-align: center;
        width:  1.2rem;
        z-index: 6000;
        position: fixed;
        top: 4.2rem;
        margin-right: 1rem;
        border-radius: 50%;
        background-color: rgba(193, 0, 35,0.5);
        transition: 0.1s background-color;

        /*touch-action: none;*/
    }
    .xuanfu:active,.xuanfu:focus{
        background-color: rgba(138, 0, 26, 0.85);
        transition: 0.1s background-color;

    }
    .yuanqiu {
        height: 1.2rem;
        width:1.2rem;
        /*border: 0.1rem solid rgba(140, 136, 136, 0.5);*/
        font-size: 0.35rem;
        line-height: 1.2rem;
        text-align: center;
        border-radius: 100%;
        /*background-color: #ffffff;*/
        /*touch-action: none;*/
        color: #fff;

    }

    .tab-nav{
        width: 7.5rem;
        right: 0;
        margin: 0 auto;
        height: 1rem;
        line-height: 1rem;
        display: flex;
        justify-content: space-between;
        background: #383838;
        color: #999;
        position: fixed;
        top: 1rem;
        left: 0px;
        z-index: 5000;
    }
    .tab-item{
        flex: 1;
        text-align: center;
        font-size: 0.35rem;
    }
    .tab-click{
        background: #FC5F1C;
        color: #fff;
    }
    .table{
        width: 100%;

        overflow:auto;
    }
    .table-title{
        font-size: 0.3rem;
        background: #CBCBCB;
        color: #000;
        width: 100%;
        height: 0.6rem;
        text-align: center;
        line-height: 0.6rem;
    }
    .tips{
        width: 100%;
        height: 1rem;
        color: #999;
        text-align: center;
        line-height: 1rem;
    }
    .table .canvas{


    }
    .table-item{
        width: 100%;
    }
    .table-item-content{
        width: 100%;
        overflow-y: auto;
    }
    .row{
        width: 100%;
        height: 0.8rem;
        border-bottom: 1px solid #f0f0f0;
        line-height: 0.8rem;
        font-size: 0.32rem;
        display: flex;
    }
    .row > span{
        flex: 1;
        text-align: center;
    }
    .row > .Lspan{
        flex:1.2;
    }
    .row > .Sspan{
        flex:0.8;

    }

    .btn{
        width: 1rem;
        height: 0.5rem;
        line-height: 0.5rem;
        margin: 0.12rem auto;
        text-align: center;
        display: block;
        border-radius: 0.05rem;
        background: #666666;
        color: #fff;
    }
</style>
